export default {
  '新增场景成功':'新增場景成功',
  '关联设备成功':'關聯設備成功',
  '编辑场景成功':'編輯場景成功',
  '设备名，SN号':'設備名，SN號',
  '保存并关闭':'保存並關閉',
  'SN码':'SN碼',
  'MAC码':'MAC碼',
  '设备列表':'設備列表',
  '设备名、SN码、MAC码':'設備名、SN碼、MAC碼',
  '添加设备':'添加設備',
  '已选中{num}人':'已選中{num}人',
  '是否确认批量移除{num}个设备？':'是否確認批量移除{num}個設備？',
  '是否确认移除设备{name}？':'是否確認移除設備{name}？',
  '场所列表':'場所列表',
  '场所名':'場所名',
  '关联设备':'關聯設備',
  '场所名称':'場所名稱',
  '场所类型':'場所類型',
  '场所ID':'場所ID',
  '请输入两位数字ID':'請輸入兩位數字ID',
  '编辑场所':'編輯場所',
  '新增场所':'新增場所',
  '确认要删除该场所吗？':'確認要刪除該場所嗎？',
  '场所删除成功！':'場所刪除成功！',
}    